var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicationNotTaken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69606 6.55414L11.0442 5.12258M6.69162 6.87611L11.4635 11.3701M4.13422 14.3721C2.8165 13.1312 2.75429 11.057 3.99525 9.73924L9.38798 4.01299C10.6289 2.69528 12.7032 2.63306 14.0209 3.87403C15.3386 5.115 15.4008 7.18922 14.1599 8.50693L8.76712 14.2332C7.52615 15.5509 5.45193 15.6131 4.13422 14.3721Z",
    stroke: "#1E89C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23982 17.9796C14.0667 17.9796 17.9796 14.0667 17.9796 9.23982C17.9796 4.41295 14.0667 0.5 9.23982 0.5C4.41295 0.5 0.5 4.41295 0.5 9.23982C0.5 14.0667 4.41295 17.9796 9.23982 17.9796Z",
    stroke: "#B11D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24573 4.24561L14.2341 14.234",
    stroke: "#B11D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationNotTaken);
export default __webpack_public_path__ + "static/media/MedicationNotTaken.0959e333.svg";
export { ForwardRef as ReactComponent };